import { Color, Object3D } from 'three';
import { isMesh } from '../utils/typeUtils';
const DEFAULT_SELECTION_COLOR = new Color(0x0000ff);
function hasColorProperty(material) {
    return material.color !== undefined;
}
export function isSelectableObject3D(object) {
    return object && object.isSelectableObject3D === true;
}
export class SelectableObject3D extends Object3D {
    constructor(selectionColor = DEFAULT_SELECTION_COLOR) {
        super();
        this.isSelectableObject3D = true;
        this.baseColors = new Map();
        this.selectionColor = selectionColor;
    }
    initBaseColors() {
        this.traverse((child) => {
            if (isMesh(child)) {
                if (Array.isArray(child.material)) {
                    child.material.forEach(this.registerColor.bind(this));
                }
                else {
                    this.registerColor(child.material);
                }
            }
        });
    }
    registerColor(material) {
        if (hasColorProperty(material)) {
            this.baseColors.set(material.uuid, material.color);
        }
    }
    addSelectionColorToMaterial(material) {
        if (hasColorProperty(material)) {
            const baseColor = this.baseColors.get(material.uuid);
            if (baseColor) {
                material.color = baseColor.clone().lerp(this.selectionColor, 0.5);
            }
        }
    }
    resetMaterial(material) {
        if (hasColorProperty(material)) {
            const baseColor = this.baseColors.get(material.uuid);
            if (baseColor) {
                material.color = baseColor.clone();
            }
        }
    }
    select() {
        this.traverse((child) => {
            if (isMesh(child)) {
                if (Array.isArray(child.material)) {
                    child.material.forEach(this.addSelectionColorToMaterial.bind(this));
                }
                else {
                    this.addSelectionColorToMaterial(child.material);
                }
            }
        });
    }
    deselect() {
        this.traverse((child) => {
            if (isMesh(child)) {
                if (Array.isArray(child.material)) {
                    child.material.forEach(this.resetMaterial.bind(this));
                }
                else {
                    this.resetMaterial(child.material);
                }
            }
        });
    }
}
